interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(page: number, total: number): (number | string)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(total - 1, page + 1);
  if (start > 2) pages.push("left-ellipsis");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("right-ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const btnBase =
    "min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm border transition-colors cursor-pointer";

  return (
    <div className="flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${btnBase} ${
          page <= 1
            ? "border-background-200 text-foreground-300 cursor-not-allowed"
            : "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        上一页
      </button>

      {buildPages(page, totalPages).map((p) =>
        typeof p === "string" ? (
          <span key={p} className="px-1 text-foreground-400">
            ···
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === page
                ? "bg-primary-500 border-primary-500 text-background-50"
                : "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        )
      )}

      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btnBase} ${
          page >= totalPages
            ? "border-background-200 text-foreground-300 cursor-not-allowed"
            : "border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        下一页
      </button>
    </div>
  );
}